@import (reference) '../../constants/spacing.module.less';
@import '~style-sheet-helpers/core.less';

.top-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: @space-24;
}

.actions-container {
  display: flex;
  gap: @space-12;
}

.action-button {
  min-width: 120px;
}

.designer {
  display: flex;
  gap: @space-24;
  padding: @space-24;
  background-color: var(--grey-100);
  width: 100%;
}

.preview {
  border: 1px solid var(--grey-300);
  display: block;
  overflow: hidden;
  background-color: var(--white);
}
